import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Drives the generic compose dialog. Each trigger button carries the URL of the
// draft to load and the URL the composed email posts to, so one modal serves every
// kind of templated portal email.
export default class extends Controller {
  static targets = ["modal", "form", "title", "to", "subject", "body", "attachments", "submitButton", "skipButton", "error"]

  connect() {
    this.modal = new Modal(this.modalTarget)
  }

  async compose(event) {
    event.preventDefault()
    const { draftUrl, actionUrl, title, submitLabel, skipLabel } = event.currentTarget.dataset

    this.formTarget.action = actionUrl
    this.titleTarget.textContent = title
    this.submitButtonTarget.textContent = submitLabel
    this.errorTarget.textContent = ''
    this.errorTarget.hidden = true

    if (skipLabel) {
      this.skipButtonTarget.textContent = skipLabel
      this.skipButtonTarget.hidden = false
    } else {
      this.skipButtonTarget.hidden = true
    }

    this.setFields({ to: 'Loading...', subject: 'Loading...', body: 'Loading...' })
    this.attachmentsTarget.value = ''
    this.setDisabled(true)
    this.modal.show()

    try {
      const response = await fetch(draftUrl, { headers: { 'Accept': 'application/json' } })
      if (!response.ok) {
        throw new Error(`Draft request failed with status ${response.status}`)
      }
      this.setFields(await response.json())
      this.setDisabled(false)
    } catch (error) {
      console.error('Error loading email draft:', error)
      this.setFields({ to: '', subject: '', body: '' })
      this.errorTarget.textContent = 'Could not load the email draft. Please close this dialog and try again.'
      this.errorTarget.hidden = false
    }
  }

  setFields({ to, subject, body }) {
    this.toTarget.value = to
    this.subjectTarget.value = subject
    this.bodyTarget.value = body
  }

  setDisabled(disabled) {
    this.submitButtonTarget.disabled = disabled
    this.skipButtonTarget.disabled = disabled
  }
}
